import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { readLocalStorage, writeLocalStorage } from "app/core/utils/platform.util";

@Injectable({ providedIn: "root" })
export class LanguageService {
  public languages: string[] = ["en", "es", "de", "fr"];

  constructor(public translate: TranslateService) {
    this.translate.addLangs(this.languages);

    let browserLang = readLocalStorage("language", "");
    if (!browserLang) {
      browserLang = "en";
      writeLocalStorage("language", "en");
    }

    translate.use(browserLang);
  }

  public setLanguage(lang: string): void {
    this.translate.use(lang);
  }

  public getActiveLanguage(): string {
    return readLocalStorage("language", "en");
  }

  whenReady(): Observable<any> {
    const lang = this.getActiveLanguage() || this.translate.currentLang || "en";
    return this.translate.use(lang);
  }
}
